import { Typography } from '@mui/material';
import dayjs from 'dayjs';

// "Set by ADEEB NASIR P K · 7 Oct 2026, 18:25" - who saved a threshold / config and when. Several people can open the config screens,
// so each row says who made it. The API sends `created_by_name` + `created_at` (and `updated_by_name` + `updated_at`) on every config
// row (src/warningDashboard/userNames.js on the server); the caller picks the pair that applies to its screen:
//   versioned thresholds        -> created_by_name / created_at   (each version is a new row, saved by whoever edited it)
//   edited-in-place rows        -> the last saver (see lastSaver below)
// Nobody recorded (an older row) = nothing is drawn, rather than a dash that looks like missing data.
const SetBy = ({ name, at, label = 'Set by', sx }) => {
  if (!name) return null;
  const when = at && dayjs(at).isValid() ? dayjs(at).format('D MMM YYYY, HH:mm') : null;
  return (
    <Typography variant="caption" color="text.secondary" component="div" sx={sx}>
      {when ? `${label} ${name} · ${when}` : `${label} ${name}`}
    </Typography>
  );
};

// Rows that are edited IN PLACE (Marketing expense, CRO Pending Tasks stages) keep their first creator, so "who set the value now" is
// the last person who saved it: the updater when there is one, else the creator.
export const lastSaver = (row) => (row?.updated_by_name
  ? { name: row.updated_by_name, at: row.updated_at }
  : { name: row?.created_by_name, at: row?.created_at });

export default SetBy;
